import { useLocation } from 'wouter';
import { useEffect, useRef } from 'react';

export function PageTransition({ children }: { children: React.ReactNode }) {
  const [location] = useLocation();
  const divRef  = useRef<HTMLDivElement>(null);
  const prevRef = useRef(location);

  useEffect(() => {
    if (prevRef.current !== location && divRef.current) {
      // Re-trigger animation by removing and re-adding the class
      divRef.current.classList.remove('sc-page-in');
      void divRef.current.offsetWidth; // force reflow
      divRef.current.classList.add('sc-page-in');
      prevRef.current = location;
    }
  }, [location]);

  return (
    <div ref={divRef} className="sc-page-in h-full flex flex-col min-h-0 flex-1">
      {children}
    </div>
  );
}
